export enum UserOperatorListRequestOrder {
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  USERNAME_ASC = "USERNAME_ASC",
  USERNAME_DESC = "USERNAME_DESC",
}

export enum UserOperatorListRequestStatusCriteria {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  ALL = "ALL",
}

export type UserOperatorListRequestQueryParams = {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserOperatorListRequestStatusCriteria;
  order?: UserOperatorListRequestOrder;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

type UserOperatorListRequest = {
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserOperatorListRequestStatusCriteria;
  order?: UserOperatorListRequestOrder;
};

export default UserOperatorListRequest;
